import { User } from 'src/app/user/model/user';

export interface FilterFunction
{
    id: number;
    version: number;
    name: string;
    functionCode: string;
    dataType: string;
    columnNameVar1: string;
    columnNameVar2: string;
    columnNameVar3: string;
}

export class ReportEdit
{
    public id = null;
    public version = 0;
    public name = '';
    public description = '';
    public reportType = '';
    public sqlViewName = '';
    public sqlViewFilter = null;
    public privateReport = false;
    public users: User[] = [];
    public filterFunctions: FilterFunction[] = [];
}
